<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload {{ modelFor }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal('')" [disabled]="showLoader"></button>
</div>

<div class="modal-body">
    <div class="drop_box">
        <p class="m-0" style="font-size: 22px; margin-bottom: 5px">
            <i class="fa-solid fa-upload"></i>
        </p>
        <header>
            <h4>Select {{ modelFor }} File here</h4>
        </header>
        <p class="m-0">Files Supported: ZIP, RAR, PDF only</p>

        <div class="load-img" *ngIf="showLoader">
            <img class="loader-spinner" src="/assets/img/loader/spinner.gif" title="loading"/>
       </div>

       <p class="m-0 upload-file-name" *ngIf="fileName" style="color: #4044bb; font-weight: 500">
           Uploading : {{ fileName }}
       </p>
        <!--this message will be shown if upload time is more-->
        <!-- <p class="m-0 upload-file-name" style="color: #484bbc; font-weight: 500">Almost there! Thanks for your patience.</p> -->

        <input type="file" hidden accept=".zip, .rar, .pdf" id="fileInvoice" style="display: none"
            (change)="onFileChange($event)" />
        <label class="btn btn-primary my-2" for="fileInvoice" *ngIf="!showLoader">
            <i class="fa fa-solid fa-cloud-arrow-up"></i> Upload & Process {{ modelFor }}
        </label>
    </div>
</div>
<div class="modal-footer">
    <div class="row m-0 w-100">
        <div class="col-lg-7 col-md-7 col-sm-6 col-6 px-1" style="text-align: left">
            <div class="alert alert-danger alert-mini" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-6 col-6 px-1" style="text-align: right">
            <!-- <button type="button" class="btn btn-success btn-shadow" (click)="c('Save')"><i class="fa fa-regular fa-eye"></i> View</button> -->
            <button type="button" class="btn btn-secondary btn-shadow my-0" (click)="closeModal('')"
                [disabled]="showLoader">
                <i class="fa fa-regular fa-circle-xmark"></i> Cancel
            </button>
        </div>
    </div>
</div>